export class DeleteRecurringPaymentRequest {
    accountId!:string;
    confirmationCode!:string;
}